import { Link, IconButton } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import MailIcon from "@mui/icons-material/Mail";

export function SocialLinks({ label }) {
  return (
    <nav className="social-links" aria-label={label}>
      <IconButton aria-label="Facebook" href="https://www.facebook.com/Positive-NRG-Gym-1982447392037524/" target="_blank" rel="noopener noreferrer">
        <FacebookIcon />
      </IconButton>
      <IconButton aria-label="Instagram" href="https://www.instagram.com/nrg.gym.lota/" target="_blank" rel="noopener noreferrer">
        <InstagramIcon />
      </IconButton>
      <IconButton aria-label="Email" href="mailto:lee@positivenrgfitness.com">
        <MailIcon />
      </IconButton>
    </nav>
  );
}

function Socials() {
  return (
    <footer className="site-footer">
      <SocialLinks label="Footer social links" />
      <p>
        Website created by{" "}
        <Link href="https://github.com/braydonburn" target="_blank" rel="noopener noreferrer">
          Braydon Burn
        </Link>
      </p>
    </footer>
  );
}

export default Socials;
